/**
 * ほかの人の書類の詳細（勤務表・業務報告・経費精算・通勤費精算・休暇申請）を開いて、
 * サーバが読み込みを 403 で断ったときの行き先。
 *
 * 割り当てられた承認者は、自分宛ての書類の詳細を開ける。自分宛てでない書類
 * （別の月・差し戻したあとの書類など）の URL を開くと、画面の入口は通って、
 * サーバが中身を断る。そのとき小窓を出すだけだと、見出しだけの空の画面が残る
 * （次にどうすればよいかが分からない）。断られたら、権限が無いときと同じ
 * 断りの画面へ移す。
 *
 * 403 でなければ何もしない（false を返す。呼んだ側が今までどおり扱う）。
 */
export function leaveWhenDetailIsRefused (router, error) {
  const status = error && error.response ? error.response.status : 0
  if (status !== 403) return false
  const moved = router.replace({ name: 'AccessDenied', query: { reason: 'ROLE' } })
  // 同じ行き先への二重の移動などで断られても、ここでは何もしない。
  if (moved && typeof moved.catch === 'function') moved.catch(() => {})
  return true
}
